// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__page--LKR4V {
  display: flex;
  flex-direction: column;
  margin: 2rem 0 2rem 2rem;
  padding: 1.5rem 3rem 1.5rem 1.5rem;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  border-radius: 1rem;
}
.style__header--d1IDY {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.style__headerName--u3U2x {
  display: flex;
  flex-direction: row;
  gap: 0.75rem;
  margin: 1rem 0;
  align-items: center;
  align-content: center;
}
.style__tagContainer--h42A9 {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
}
.style__content--p8Ozw {
  display: flex;
  gap: 2rem;
  overflow: auto;
  margin-bottom: 1rem;
}
.style__content--p8Ozw > div:first-of-type {
  width: 70%;
}
.style__infoContainer--MZx6Z {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.style__defaultItemIcon--eMmJV {
  border-radius: 50%;
  background-color: #e3e4e8;
  height: 2rem;
  width: 2rem;
  color: #0c0d0d;
  display: flex;
  justify-content: center;
  align-items: center;
}
.style__errorItemIcon--OGAKe {
  border-radius: 50%;
  background-color: #e3e4e8;
  height: 2rem;
  width: 2rem;
  color: #0c0d0d;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff3f0;
  color: #d72a1d;
}
.style__successItemIcon--oMT_P {
  border-radius: 50%;
  background-color: #e3e4e8;
  height: 2rem;
  width: 2rem;
  color: #0c0d0d;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #eaffe9;
  color: #00a751;
}
.style__defaultItemIcon--eMmJV {
  border-radius: 50%;
  background-color: #e3e4e8;
  height: 2rem;
  width: 2rem;
  color: #0c0d0d;
  display: flex;
  justify-content: center;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/KitDetailsPage/style.less"],"names":[],"mappings":"AAGA;EAEI,aAAA;EACA,sBAAA;EACA,wBAAA;EACA,kCAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;AAHJ;AANA;EAaI,aAAA;EACA,mBAAA;EACA,8BAAA;AAJJ;AAXA;EAmBI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,qBAAA;AALJ;AAnBA;EA4BI,aAAA;EACA,mBAAA;EACA,WAAA;AANJ;AAxBA;EAkCI,aAAA;EACA,SAAA;EACA,cAAA;EACA,mBAAA;AAPJ;AA9BA;EAwCM,UAAA;AAPN;AAjCA;EA6CI,aAAA;EACA,sBAAA;EACA,SAAA;AATJ;AAtCA;EAmDI,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAVJ;AAhDA;EA0EI,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAlBA,yBAAA;EACA,cAAA;AAJJ;AA5DA;EA0EI,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAZA,yBAAA;EACA,cAAA;AAEJ;AAxEA;EA0EI,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACJ","sourcesContent":["@import '@yaak/components/src/colors';\n@import '@yaak/components/src/shadows';\n\n:local {\n  .page {\n    display: flex;\n    flex-direction: column;\n    margin: @spacing-200 0 @spacing-200 @spacing-200;\n    padding: @spacing-150 @spacing-300 @spacing-150 @spacing-150;\n    width: 100%;\n    height: 100%;\n    background-color: #ffffff;\n    border-radius: @spacing-100;\n  }\n\n  .header {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n  }\n\n  .headerName {\n    display: flex;\n    flex-direction: row;\n    gap: @spacing-75;\n    margin: @spacing-100 0;\n    align-items: center;\n    align-content: center;\n  }\n\n  .tagContainer {\n    display: flex;\n    flex-direction: row;\n    gap: @spacing-50;\n  }\n\n  .content {\n    display: flex;\n    gap: @spacing-200;\n    overflow: auto;\n    margin-bottom: @spacing-100;\n\n    > div:first-of-type {\n      width: 70%;\n    }\n  }\n\n  .infoContainer {\n    display: flex;\n    flex-direction: column;\n    gap: @spacing-100;\n  }\n\n  .defaultItemIcon {\n    border-radius: 50%;\n    background-color: @color-asphalt-grey-090;\n    height: @spacing-200;\n    width: @spacing-200;\n    color: @color-pewter-grey-005;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .errorItemIcon {\n    .defaultItemIcon;\n    background-color: @color-red-099;\n    color: @color-red-050;\n  }\n\n  .successItemIcon {\n    .defaultItemIcon;\n    background-color: @color-green-099;\n    color: @color-green-060;\n  }\n\n  .defaultItemIcon {\n    border-radius: 50%;\n    background-color: @color-asphalt-grey-090;\n    height: @spacing-200;\n    width: @spacing-200;\n    color: @color-pewter-grey-005;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `style__page--LKR4V`,
	"header": `style__header--d1IDY`,
	"headerName": `style__headerName--u3U2x`,
	"tagContainer": `style__tagContainer--h42A9`,
	"content": `style__content--p8Ozw`,
	"infoContainer": `style__infoContainer--MZx6Z`,
	"defaultItemIcon": `style__defaultItemIcon--eMmJV`,
	"errorItemIcon": `style__errorItemIcon--OGAKe`,
	"successItemIcon": `style__successItemIcon--oMT_P`
};
export default ___CSS_LOADER_EXPORT___;
